'use strict';

module.exports = require('./lib')



//////////////////
// WEBPACK FOOTER
// ./node_modules/promise/index.js
// module id = 1000
// module chunks = 0